<template>
  <v-card min-height="640" class="mt-6">
    <v-card-title>
      Carpetas
      <v-spacer></v-spacer>
      <v-container>
        <v-row>
          <v-col cols="8">
            <folder-create :folder="folder" />
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col class="text-h2" cols="4">
          <folder-tree searchable @onChangeActionFolder="changeActiveFolder" />
        </v-col>
        <v-col class="text-h2" cols="8">
          <documents-table :folder="folder" from="foldertable" :headers="documentsHeaders" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import FolderTree from '@/modules/catalogs/components/FolderTree'
import FolderCreate from '@/modules/catalogs/components/FolderCreate'
import DocumentsTable from '@/modules/documents/components/DocumentsTable'

export default {
  name: 'FolderTable',
  data() {
    return {
      folder: null,
      documentsHeaders: [
      { text: 'Clave', value: 'clave', sortable: false, width: '110' },
      { text: 'Tipo Documento', value: 'idTipoDocumento', sortable: false, width: '170', order: 'tipoDocumento' },
      { text: 'Nombre del documento', value: 'descripcion', sortable: false, width: '220', order: 'nombreDocumento' },
      { text: 'Estado', value: 'estatus', sortable: false, width: '90', order: 'estado' },
      { text: 'Fecha de expiración', value: 'fechaExpiracion', sortable: false, width: '120' },
      { text: 'Firmantes', value: 'firmantes', sortable: false, width: '230' },
      { text: 'Acciones', value: 'actions', sortable: false, width: '80' }
    ],
    search: '',
    searchDelay: '',
    }
  },
  components: {
    FolderTree,
    FolderCreate,
    DocumentsTable
  },
  methods: {
    changeActiveFolder(node) {
      this.folder = node
    }
  }
}
</script>
